import { render, staticRenderFns } from "./NumberAccTransactions.vue?vue&type=template&id=0029254e"
import script from "./NumberAccTransactions.vue?vue&type=script&lang=js"
export * from "./NumberAccTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports